var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"font-size":"12px","color":"#0E193B"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"font-size":"14px","color":"#0E193B","font-weight":"bold","margin-top":"6px"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }